import Form from 'src/utils/Form.js'

class TransferLimit extends Form {
    constructor(data) {
        super(data);
    }

    static allByUser(user_id, then) {
        return new Form().get(`/users/${user_id}/transfer-limits`).then(then)
    }

    static userTransferLimits(parameters, then) {
        return new Form().get(`/transfer-limits?${parameters}`).then(then)
    }

    create(then) {
        return super.post('/transfer-limits').then(then);
    }

    update(then) {
        return super.patch('/transfer-limits/' + this.id).then(then);
    }

    destroy(then) {
        return super.delete(`/transfer-limits/${this.id}`).then(then);
    }
}

export default TransferLimit;
